export function scrollToSection(targetId: string): void {
    const el = document.getElementById(targetId);
    if (!el) {
        return;
    }

    const nav = document.querySelector("nav");
    const navHeight = nav?.getBoundingClientRect().height ?? 0;
    const top = el.getBoundingClientRect().top + window.scrollY - navHeight;

    window.scrollTo({ top, behavior: "smooth" });
}
